export enum IrbAppEvents {
    SHOW_WAIT = "IRBAPPEVENTS.SHOW_WAIT",
    HIDE_WAIT = "IRBAPPEVENTS.HIDE_WAIT",
    GRID_REFRESH = "IRBAPPEVENTS.GRID_REFRESH",
    GRID_COLUMN_RESET = "IRBAPPEVENTS.GRID_COLUMN_RESET",
    GRID_FILTER_RESET = "IRBAPPEVENTS.GRID_FILTER_RESET",
    SHOW_TOAST = "IRBAPPEVENTS.SHOW_TOAST",
    HIDE_TOAST = "IRBAPPEVENTS.HIDE_TOAST",
    SHOW_ALERT = "IRBAPPEVENTS.SHOW_ALERT",
    SHOW_CONFIRMATION = "IRBAPPEVENTS.SHOW_CONFIRMATION",
    FIRE_TRACKING_EVENT = "IRBAPPEVENTS.FIRE_TRACKING_EVENT"
}
